// Use Markdown format
export const contentPrivacyPolicy = `
AutoveX’s RoboHub (“we”, “our”, “us”) respects your privacy and is committed to protecting your personal data in accordance with the **Singapore Personal Data Protection Act 2012 (PDPA)**. This policy explains how we collect, use, disclose, and safeguard your information when you use our platform, applications, and services.

----------

###### **1. Collection of Personal Data**

We collect personal data that you provide or that arises from your use of RoboHub, including:

-   Name, contact details, organisation, job title.
-   Login credentials and account information.
-   Job and delivery records, access logs, and operational data.
-   Device, network, and location information.
-   Any other information you choose to share with us.

----------

###### **2. Purpose of Use**

We collect and use personal data to:

-   Provide and operate RoboHub services.
-   Authenticate users and control access.
-   Manage jobs, scheduling, and notifications.
-   Respond to enquiries and support requests.
-   Improve system performance and user experience.
-   Comply with laws and regulatory requirements.

We will seek your consent before using your data for any other purposes.

----------

###### **3. Disclosure of Personal Data**

We may disclose personal data to:

-   Service providers and integration partners supporting our operations.
-   Regulatory or government authorities where required by law.
-   Third parties in the event of a merger, acquisition, or business transfer.

All third parties are required to protect your data in compliance with the PDPA.

----------

###### **4. Protection of Personal Data**

We implement security measures including encryption, access controls, and monitoring to safeguard your data from unauthorised access, use, or disclosure.

----------

###### **5. Retention**

We retain personal data only as long as necessary for the purposes outlined or as required by law. Data no longer needed will be securely deleted or anonymised.

----------

###### **6. Access, Correction, and Withdrawal of Consent**

You may request:

-   Access to your personal data.
-   Correction of inaccuracies.
-   Withdrawal of consent for data usage.

Requests can be made to our Data Protection Officer (see Section 8).

----------

###### **7. Transfer of Data Overseas**

If personal data is transferred outside Singapore, we will ensure the recipient provides a comparable standard of protection in line with the PDPA.

----------

###### **8. Contact Us**

AutoveX Pte Ltd\n
Email: [contact@autovex.ai](mailto:contact@autovex.ai)\n
Address: 73, Ayer Rajah Crescent, #01-07, Singapore 139952\n

----------

###### **9. Updates to Policy**

We may update this Privacy Policy from time to time. Changes will be posted on our website with the effective date.
`;